import { render, staticRenderFns } from "./surveyFormsTable.vue?vue&type=template&id=90abfc40&scoped=true"
import script from "./surveyFormsTable.vue?vue&type=script&lang=js"
export * from "./surveyFormsTable.vue?vue&type=script&lang=js"
import style0 from "./surveyFormsTable.vue?vue&type=style&index=0&id=90abfc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90abfc40",
  null
  
)

export default component.exports